export const defaultStateSelector =
    <State, K extends string>(key: K) =>
    <T extends Record<K, State>>(state: T) =>
        state[key];
